<template>
  <BField
    :label="label"
    :label-for="id"
    :message="message"
    :type="{ 'is-danger': !valid }"
    :custom-class="customClass"
  >
    <BInput
      :id="id"
      ref="input"
      :name="name"
      type="email"
      icon="email"
      maxlength="50"
      placeholder="correo@mail.com"
      :value="value"
      :loading="loading"
      :required="required"
      :disabled="disabled"
      :has-counter="false"
      @focus="onFocus"
      @input="onChange"
      @change="onChange"
      @blur="onBlur"
    />
  </BField>
</template>

<script>
import set from 'lodash/set';

export default {
  name: 'AppInputEmail',
  props: {
    id: { type: [String, Number], default: 'email' },
    name: { type: [String, Number], default: 'email' },
    value: { type: String, default: '' },
    label: { type: String, default: 'Correo' },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    errorMessage: {
      type: [String, Array],
      default: () => [
        'El email debe tener este formato:',
        'ejemplo@dominio.com',
      ],
    },
  },
  data() { return { valid: true }; },
  computed: {
    customClass() { return !this.valid ? 'has-text-danger' : ''; },
    message() { return !this.valid ? this.errorMessage : ''; },
  },
  methods: {
    toLowerCase(event) {
      const value = event.toLowerCase();

      const newEvent = {};

      set(newEvent, 'target.name', this.name);
      set(newEvent, 'target.value', value);

      return newEvent;
    },
    onFocus(event) {
      this.valid = true;
      this.$emit('focus', event);
    },
    onInput(event) { this.$emit('input', this.toLowerCase(event)); },
    onChange(event) { this.$emit('change', this.toLowerCase(event)); },
    onBlur(event) {
      this.valid = event.target.value.length > 0 ? event.target.checkValidity() : true;
      this.$emit('blur', event);
    },
    focus() {
      this.$refs.input.focus();
    },
    checkValidation() {
      this.$refs.input.checkHtml5Validity();
    },
  },
};
</script>
